"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ScoreCard_1 = require("../components/ScoreCard");
var ScoreTabContainer_1 = require("./ScoreTabContainer");
var FooterContainer_1 = require("./FooterContainer");
var common_1 = require("@shine-api/common");
var ScoreContainer = function (_super) {
  __extends(ScoreContainer, _super);
  function ScoreContainer(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      selectedIndex: 0
    };
    return _this;
  }
  ScoreContainer.prototype.selectTab = function (selectedIndex, name) {
    common_1.track("Tab Selected - " + name);
    this.setState({
      selectedIndex: selectedIndex
    });
  };
  ScoreContainer.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      scores = _a.scores,
      lat = _a.lat,
      lon = _a.lon;
    var selectedIndex = this.state.selectedIndex;
    return React.createElement("div", {
      className: 'ths-score-container'
    }, React.createElement(ScoreTabContainer_1.ScoreTabContainer, {
      scores: scores,
      selectedIndex: selectedIndex,
      selectTab: function selectTab(index, name) {
        return _this.selectTab(index, name);
      }
    }), React.createElement(ScoreCard_1.ScoreCard, __assign({}, scores[selectedIndex])), React.createElement(FooterContainer_1.FooterContainer, {
      lat: lat,
      lon: lon
    }));
  };
  return ScoreContainer;
}(React.Component);
exports.ScoreContainer = ScoreContainer;